export default __webpack_public_path__ + "static/media/scenic.6506fe86.png";